<template>
    <div class="or-admin-image-loader flex-row">
        <div class="image-container">
            <img :src="options.image" class="image" v-show="this.options.image"/>
        </div>
        <div class="buttons">
            <label :for="`file_${options.id}_${options.input_postfix}`" class="label">
                <p class="upload button hover-pointer hover-yellow" v-show="!this.options.image">Загрузить изображение</p>
                <p class="change button hover-pointer hover-yellow" v-show="this.options.image">Заменить изображение</p>
            </label>
            <!-- <p class="delete button hover-pointer hover-red" v-show="this.options.image" @click="clear">Удалить</p> -->
        </div>
        <input :id="`file_${options.id}_${options.input_postfix}`" class="file" ref="file" type="file" @change="getFile"/>
    </div>
</template>

<script>
export default {
    props: {
        options: Object
    },
    methods: {
        async getFile() {
            const file = this.$refs.file.files[0];
            await this._convertToBase64(file);
        },
        _convertToBase64(file) {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => {
                this.options.image = reader.result;
                this.$emit('unsaved');
            }
        },
        clear() {
            this.options.image = null;
        }
    }
}
</script>

<style scoped>
    .image-container {
        width: 238px;
        height: 158px;
        border: #bfbfbf solid 1px;
        border-radius: 8px;
        overflow: hidden;
        margin-right: 30px;
    }
    .image {
        width: 100%;
        height: 100%;
        -o-object-fit: cover;
        object-fit: cover;
        -o-object-position: cover;
        object-position: center;
    }
    .file {
        display: none;
    }
    .buttons {
        color: black;
        font-size: 14px;
        line-height: 16px;
        text-align: left;
    }
    .button {
        margin-bottom: 10px;
    }
    .delete {
        color: #bfbfbf;
    }
</style>